import { Box, Container, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";


export const QuienesSomosHome = () => {


  const sectionRef = useRef(null);

  const [visible,setVisible] = useState(false);



  // Reiniciar animación al entrar y salir
  useEffect(()=>{


    const observer = new IntersectionObserver(
      ([entry])=>{

        if(entry.isIntersecting){

          setVisible(true);

        }else{

          setVisible(false);

        }

      },
      {
        threshold:0.25
      }
    );


    if(sectionRef.current){

      observer.observe(sectionRef.current);

    }


    return ()=>observer.disconnect();


  },[]);





return (

<section

style={{

width:"100%",

position:"relative",

overflow:"hidden",

marginTop:'50px',
marginBottom:'50px'

}}

>


<Box

ref={sectionRef}

sx={{

position:"relative",

width:"100%",

overflow:"hidden",

py:{
xs:7,
sm:8,
md:10,
lg:12
},


opacity:visible ? 1 : 0,


transform:visible
?
"translateY(0)"
:
"translateY(60px)",


transition:"1s ease"

}}

>




{/* =====================
        GLOW FONDO
===================== */}


<Box

sx={{

position:"absolute",

width:600,

height:600,

borderRadius:"50%",

background:"#7485ff18",

filter:"blur(160px)",

top:-250,

right:-250,

zIndex:0

}}

/>










{/* =========================
      RED NEURONAL ANIMADA
========================= */}

<Box
sx={{
  position:"absolute",
  inset:0,
  width:"100vw",
  height:"100%",
  zIndex:0,
  pointerEvents:"none",
}}
>

<svg
width="100%"
height="100%"
viewBox="0 0 1920 600"
preserveAspectRatio="none"
>


<defs>

<linearGradient id="neuralLine">

<stop 
offset="0%"
stopColor="#484a75"
stopOpacity="0.05"
/>


<stop
offset="50%"
stopColor="#6f8cff"
stopOpacity="0.5"
/>


<stop
offset="100%"
stopColor="#4fc3f7"
stopOpacity="0.1"
/>

</linearGradient>


</defs>




{/* CONEXIONES */}

<g
fill="none"
stroke="url(#neuralLine)"
strokeWidth="1.5"
>


{

[
"M1500 120 L1630 180",
"M1630 180 L1740 100",
"M1740 100 L1860 160",
"M1630 180 L1700 300",
"M1700 300 L1840 360",
"M1700 300 L1580 390",


"M120 150 L250 220",
"M250 220 L360 130",
"M250 220 L330 340",
"M330 340 L470 400",
"M360 130 L500 190"

].map((path,i)=>(


<path

key={i}

d={path}

strokeDasharray="300"

strokeDashoffset={
visible ? 0 : 300
}


style={{

transition:
visible
?
`stroke-dashoffset 1.8s ease ${i*0.7}s`
:
"none"

}}


/>


))


}



</g>







{/* NODOS */}

{


[

[1500,120],
[1630,180],
[1740,100],
[1860,160],
[1700,300],
[1840,360],
[1580,390],


[120,150],
[250,220],
[360,130],
[330,340],
[470,400],
[500,190]


].map(([x,y],i)=>(


<circle

key={i}

cx={x}

cy={y}

r="3"

fill="#7c8cff"


style={{

opacity:visible?1:0,

transition:

visible

?

`opacity .5s ease ${i*0.7}s`

:

"none"

}}

>



<animate

attributeName="r"

values="3;5;3"

dur="3s"

repeatCount="indefinite"

/>


<animate

attributeName="opacity"

values=".4;1;.4"

dur="4s"

repeatCount="indefinite"

/>


</circle>


))


}



</svg>


</Box>









{/* =====================
        CONTENIDO
===================== */}



<Container

maxWidth="lg"

sx={{

position:"relative",

zIndex:2

}}

>


<Box

sx={{

display:"flex",

alignItems:"center",

justifyContent:"center",

flexDirection:"column",

textAlign:"center"

}}

>




<Typography

sx={{

color:"#484a75",

fontWeight:700,

textTransform:"uppercase",

letterSpacing:{
xs:"1px",
md:"2px"
},

mb:1,


fontSize:{
xs:"1rem",
sm:"1.2rem",
md:"1.5rem",
lg:"1.8rem"
},


opacity:visible?1:0,


transform:visible
?
"translateY(0)"
:
"translateY(25px)",


transition:".7s"

}}

>

Colegio Antilén

</Typography>







<Typography

sx={{

fontWeight:700,

color:"#2b2b2b",

mb:2,

lineHeight:1.2,


fontSize:{
xs:"1.8rem",
sm:"1.8rem",
md:"2rem",
lg:"3rem"
},


opacity:visible?1:0,


transform:visible
?
"translateY(0)"
:
"translateY(35px)",


transition:".9s",

transitionDelay:".2s"

}}

>

Quiénes Somos

</Typography>








<Box

sx={{

width:visible?
90:0,


height:4,


background:"#c69ba5",

borderRadius:"50px",

mb:5,


transition:"width .9s ease"

}}

/>







<Typography

sx={{

fontWeight:500,

color:"#666",


maxWidth:"900px",


fontSize:{
xs:"1rem",
sm:"1.15rem",
md:"1.3rem",
lg:"1.5rem"
},


lineHeight:1.9,


textAlign:"center",


opacity:visible?1:0,


transform:visible
?
"translateY(0)"
:
"translateY(40px)",


transition:"1s",

transitionDelay:".6s"


}}

>

El <strong>Colegio Antilén</strong> nace como una necesidad de cubrir
las demandas educativas que los padres y apoderados buscaban en
nuestra comuna. La formación de personas íntegras y responsables de
su entorno hacen del Colegio Antilén una institución ideal, lo que se
refleja en la alegría de nuestros estudiantes y en la gran aceptación
y confianza de toda la comunidad educativa.


</Typography>



</Box>


</Container>




</Box>


</section>

);


};